import { render } from "./HeaderComponent.vue?vue&type=template&id=5eb7de86&ts=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=ts"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__